import formatBase from 'date-fns/format';
import { getLocale } from './getLocale';

export function format(
    date: number | Date,
    format: string,
    options?: Parameters<typeof formatBase>[2]
): string {
    const locale = getLocale();
    return formatBase(date, format, {
        locale,
        ...options,
    });
}
